import type { ShareableNodeTypenames, Thumbnail } from "./types.js";

// TODO: improve findClosesThumbnail logic
export const findClosestThumbnail = (
    thumbnails: Thumbnail[],
    minWidth: number = 1200,
): Thumbnail => {
    const thumbnail = thumbnails.reduce<Thumbnail>((prev, current) => {
        if (
            Math.abs(current.width - minWidth) < Math.abs(prev.width - minWidth)
        ) {
            return current;
        } else {
            return prev;
        }
    }, thumbnails[0]);
    return thumbnail;
};

export const urlPathFromTypename = (
    typename: ShareableNodeTypenames,
): string => {
    switch (typename) {
        case "News":
        case "Image":
        case "Infographics":
        case "Video":
        case "Quiz":
            return typename.toLowerCase();
        case "Tutorial":
            return "tutorials";
        case "OutcomeQuiz":
            return "outcome-quiz";
        case "YoutubeVideo":
            return "youtube-video";
    }
};
